import React from "react";
import { useTranslation } from "react-i18next";
import { AutoTable } from "@rentablo/components";
import { useMediaQuery, useTheme } from "@mui/material";
import { useTableConfig } from "./useTableConfig";
import { useSupportedCSVImportBanks } from "./useSupportedCSVImportBanks";
import { BanksMobileList } from "./BanksMobileList";

export const BanksTable = () => {
  const { t } = useTranslation();
  const config = useTableConfig();
  const theme = useTheme();
  const banks = useSupportedCSVImportBanks();
  const isSm = useMediaQuery(theme.breakpoints.down("sm"));

  if (isSm && banks.length > 0) {
    return <BanksMobileList banks={banks} />;
  }

  return (
    <AutoTable
      stickyScroll={false}
      settings={config}
      data={banks}
      showNoData={banks.length === 0}
      noDataFirstLine={t("csvImport.banksTable.emptyText")}
      sx={{
        border: `1px solid ${theme.palette.border.secondary}`,
        borderRadius: "10px",
        ".MuiTableCell-root": {
          backgroundColor: theme.palette.background.subtle,
          color: theme.palette.text.secondary,
        },
      }}
    />
  );
};
